import round from 'lodash/round';
// local imports
import { spacing as spacingValue } from '../styles/themeOptions';

export function spacing(value: number): number {
  return round(value * spacingValue);
}
